import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useGlobalContext } from '@/store';

export function ErrorModal() {
  const { errorModal, closeErrorModal } = useGlobalContext();

  return (
    <Dialog open={errorModal.show} onClose={closeErrorModal} maxWidth="xs" fullWidth>
      <DialogTitle className="text-red-600">{errorModal.title}</DialogTitle>
      <DialogContent>
        <Typography>{errorModal.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeErrorModal} color="error" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
